import React from 'react';
import {r} from "@/utils/responsive";
import DisabledWrapper from "@/components/DisabledWrapper";
import {ScreensaverVideo} from "@/components/videos";
import {useNav} from "@/hooks/useNav";
import {AnimatePresence, motion} from "motion/react";
import ReactPlayer from 'react-player'
import {S3_FILES} from "@/config/s3_files";
import ReactPlayerWrapper from "@/components/ReactPlayerWrapper";

interface IntroGridProps extends React.HTMLAttributes<HTMLDivElement> {
}

const LINES_COUNT = 3;

const IntroGrid: React.FC<IntroGridProps> = ({className, ...props}) => {
    const {currentSection} = useNav()
    return (
        <div
            {...props}
            style={{
                position: 'absolute',
                inset: 0,
                pointerEvents: 'none',
                userSelect: 'none',
            }}
        >
            <ReactPlayerWrapper blurOnSections={["intro_text", "intro_universe"]} videoSrc={S3_FILES.MONSTER_VIDEO}
                                posterSrc={S3_FILES.MONSTER_VIDEO_POSTER}/>
            <AnimatePresence>
                {(currentSection === "intro_text" ||
                    currentSection === "intro_universe" || currentSection === "briefing") && (
                    <motion.div
                        initial={{opacity: 0}}
                        animate={{opacity: 1}}
                        exit={{opacity: 0}}
                        transition={{duration: 0.8, ease: "easeIn"}}
                        style={{
                            position: "absolute",
                            inset: 0,
                            zIndex: 2,
                            pointerEvents: "none",
                            userSelect: "none",
                        }}
                    >
                        <DisabledWrapper style={{
                            position: 'absolute',
                            inset: 0,
                            background: '#001A5C',
                            mixBlendMode: 'overlay',
                            opacity: .5,
                            zIndex: 2,
                        }}/>
                        <div style={{
                            position: 'absolute',
                            inset: 0,
                            zIndex: 3,
                        }}>
                            <div style={{
                                position: 'absolute',
                                inset: 0,
                                display: 'flex',
                                justifyContent: 'space-between',
                                width: '100vw',
                                height: '100vh'
                            }}>
                                <div style={{height: '100vh'}}/>
                                {Array(LINES_COUNT).keys().map((_, i) => (
                                    <div key={i}
                                         style={{
                                             height: '100vh',
                                             width: r.vmax(1),
                                             minWidth: 1,
                                             background: 'rgba(98, 87, 158, 0.9)',
                                             mixBlendMode: 'color-dodge',
                                             pointerEvents: 'none'
                                         }}/>
                                ))}
                                <div style={{height: '100vh'}}/>
                            </div>
                            <div style={{
                                position: 'absolute',
                                inset: 0,
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between',
                                width: '100vw',
                                height: '100vh',
                            }}>
                                <div style={{width: '100vw'}}/>
                                {Array(LINES_COUNT).keys().map((_, i) => (
                                    <div key={i}
                                         style={{
                                             width: '100vw',
                                             height: r.vmax(1),
                                             minHeight: 1,
                                             background: 'rgba(98, 87, 158, 0.9)',
                                             mixBlendMode: 'color-dodge',
                                             pointerEvents: 'none'
                                         }}/>
                                ))}
                                <div style={{width: '100vw'}}/>
                            </div>
                            <div style={{
                                position: 'absolute',
                                inset: 0,
                                display: "grid",
                                gridTemplateColumns: "repeat(4, 1fr)",
                                gridTemplateRows: "repeat(4, 1fr)",
                                pointerEvents: 'none'
                            }}>
                                {Array((LINES_COUNT + 1) * (LINES_COUNT + 1) - (LINES_COUNT + 1)).keys().map((_, i) => (
                                    <div key={i} style={{position: 'relative'}}>
                                        <div style={{
                                            position: 'absolute',
                                            top: '100%',
                                            left: '100%',
                                            transform: 'translate(-50%, -50%)',
                                            width: `max(${r.vmax(12)}, 12px`,
                                            height: `max(${r.vmax(12)}, 12px)`,
                                            border: `max(${r.vmax(1)}, 1px) solid #5B586A`,
                                            opacity: (i + 1) % 4 === 0 ? 0 : 1,
                                            mixBlendMode: 'color-dodge'
                                        }}/>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

export default IntroGrid;
